import React from "react";
import { NFImage } from "../Data/Assets/Images";
import { Link } from "react-router";

const NotFound = () => {
  return (
    <div className="w-full flex flex-col justify-center items-center gap-5">
      <h1 className="font-courier text-2xl lg:text-4xl font-bold text-neutral-300 tracking-widest">
        ERROR : 404
      </h1>
      <img
        src={NFImage}
        alt="404"
        className="w-full lg:w-64 shadow-[0_4px_10px_rgba(0,0,0,0.7)]"
      />
      <Link
        to={"/"}
        className="text-black font-bold font-courier py-2 px-4 bg-neutral-300 rounded-md shadow-[0_4px_10px_rgba(0,0,0,0.7)]"
      >
        HOME
      </Link>
    </div>
  );
};

export default NotFound;
